module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('h1', [_vm._v("区分测试环境和生产环境")]), _vm._v(" "), _c('p', [_vm._v("如果你使用了 "), _c('code', [_vm._v("vux2")]), _vm._v(" 模板或者 "), _c('code', [_vm._v("webpack")]), _vm._v(" 模板，默认你可以直接通过判断 "), _c('code', [_vm._v("process.env.NODE_ENV")]), _vm._v(" 来区分")]), _vm._v(" "), _c('p', [_vm._v("比如"), _c('code', [_vm._v("统计代码")]), _vm._v("仅放在 "), _c('code', [_vm._v("production")]), _vm._v(" 环境，在不同环境里使用不同的 "), _c('code', [_vm._v("API")]), _vm._v(" 接口地址。")]), _vm._v(" "), _c('pre', {
    staticClass: "hljs"
  }, [_c('code', [_c('span', {
    staticClass: "hljs-keyword"
  }, [_vm._v("if")]), _vm._v(" (process.env.NODE_ENV === "), _c('span', {
    staticClass: "hljs-string"
  }, [_vm._v("'production'")]), _vm._v(") {\n  "), _c('span', {
    staticClass: "hljs-comment"
  }, [_vm._v("// 干一些线上才要做的事情")]), _vm._v("\n}\n"), _c('span', {
    staticClass: "hljs-keyword"
  }, [_vm._v("if")]), _vm._v(" (process.env.NODE_ENV === "), _c('span', {
    staticClass: "hljs-string"
  }, [_vm._v("'development'")]), _vm._v(") {\n  "), _c('span', {
    staticClass: "hljs-comment"
  }, [_vm._v("// 干一些测试时不可告人的事情")]), _vm._v("\n}\n")])]), _vm._v(" "), _c('p', [_vm._v("如果你是自己配置的环境，可以参考 "), _c('a', {
    attrs: {
      "href": "https://webpack.js.org/plugins/define-plugin/"
    }
  }, [_vm._v("webpack DefinePlugin 文档")])])])
}]}
module.exports.render._withStripped = true
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
     require("vue-hot-reload-api").rerender("data-v-51f50554", module.exports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./~/ream/~/vue-loader/lib/template-compiler?{"id":"data-v-51f50554"}!./~/ream/~/vue-loader/lib/selector.js?type=template&index=0!./~/v-markdown-loader/_cache/vue-webpack-env-443.vue
// module id = 2736
// module chunks = 214